import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="pt-20" data-testid="privacy-page">
      {/* Hero Section */}
      <section className="py-16 md:py-20 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <Shield className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold">
              Privacy Policy
            </h1>
            <p className="mt-4 text-slate-300">Lane 4 For All Kids Foundation</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate prose-lg">
          <p className="text-slate-600"><strong>Effective Date:</strong> January 2026</p>

          <p>Lane 4 For All Kids Foundation ("we," "our," or "us") respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website, make a donation, or interact with our services.</p>

          <h2 className="font-heading">1. Information We Collect</h2>
          <p>We may collect personal information that you voluntarily provide to us when you:</p>
          <ul>
            <li>Make a donation</li>
            <li>Subscribe to our newsletter</li>
            <li>Contact us through our website</li>
            <li>Register for events</li>
            <li>Submit volunteer or sponsorship inquiries</li>
          </ul>
          <p>This information may include:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Mailing address</li>
            <li>Donation amount and transaction details</li>
            <li>Any information you voluntarily provide through forms</li>
          </ul>
          <p>Payment information such as credit card numbers is processed securely through third-party payment processors and is not stored on our servers.</p>

          <h2 className="font-heading">2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Process donations and provide donation receipts</li>
            <li>Respond to inquiries or requests</li>
            <li>Send updates about programs, events, and initiatives</li>
            <li>Improve our website and services</li>
            <li>Communicate opportunities to support our mission</li>
            <li>Maintain internal records for nonprofit compliance</li>
          </ul>
          <p>We will not sell, rent, or trade your personal information to third parties.</p>

          <h2 className="font-heading">3. Payment Processing</h2>
          <p>Online donations may be processed through secure third-party payment providers such as Stripe. These providers handle your payment information in accordance with their own privacy and security policies. Lane 4 For All Kids Foundation does not store or have access to your full credit card details.</p>

          <h2 className="font-heading">4. Cookies and Website Analytics</h2>
          <p>Our website may use cookies and analytics tools to:</p>
          <ul>
            <li>Improve website functionality</li>
            <li>Understand visitor behavior</li>
            <li>Enhance user experience</li>
          </ul>
          <p>Cookies are small data files stored on your device. You may disable cookies through your browser settings if you prefer.</p>

          <h2 className="font-heading">5. Third-Party Links</h2>
          <p>Our website may contain links to third-party websites or services. Lane 4 For All Kids Foundation is not responsible for the privacy practices or content of those external sites. We encourage visitors to review the privacy policies of any external websites they visit.</p>

          <h2 className="font-heading">6. Data Security</h2>
          <p>We take reasonable steps to protect your personal information using industry-standard security measures. However, no online system can guarantee absolute security.</p>

          <h2 className="font-heading">7. Children's Privacy</h2>
          <p>Our website is intended for general audiences and does not knowingly collect personal information directly from children under the age of 13 without parental consent.</p>

          <h2 className="font-heading">8. Your Rights and Choices</h2>
          <p>You may request to:</p>
          <ul>
            <li>Review the personal information we have about you</li>
            <li>Correct or update your information</li>
            <li>Request removal from our communications list</li>
          </ul>
          <p>To make such requests, please contact us using the information below.</p>

          <h2 className="font-heading">9. Updates to This Policy</h2>
          <p>Lane 4 For All Kids Foundation may update this Privacy Policy from time to time. Updates will be posted on this page with a revised effective date.</p>

          <h2 className="font-heading">10. Contact Information</h2>
          <p>If you have any questions regarding this Privacy Policy or how your information is used, please contact us:</p>
          <p>
            <strong>Lane 4 For All Kids Foundation</strong><br />
            Email: info@lane4foundation.com<br />
            Phone: 877.495.2634
          </p>

          <div className="mt-8 p-4 bg-amber-50 border border-amber-200 rounded">
            <p className="text-amber-800 text-sm mb-0"><strong>Important Notice:</strong> Lane 4 For All Kids Foundation is currently in the process of obtaining 501(c)(3) tax-exempt status. Donations may not yet be tax-deductible.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
